<template>
  <div id="rating-report">
    <div id="rating-report-header">
      <v-btn flat dark :to="`/bot/${activeBot.code}`" class="report-back-btn text-capitalize">
        <v-icon class="mr-1">mdi-arrow-left-bold-circle-outline</v-icon>
        back
      </v-btn>
      <span id="rating-report-header-title">{{ $t('ratingReport')|capitalize }}</span>
      <div id="rating-report-header-bot-list">
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on }">
            <div v-on="on" id="rating-report-header-active-bot">
              <span>{{ activeBot ? activeBot.name : '' }}</span>
              <v-icon color="#fff">mdi-chevron-down</v-icon>
            </div>
          </template>
          <div id="rating-report-header-bot-list-menu">
            <v-list>
              <v-list-tile
                  v-for="bot in botList"
                  :key="bot.code"
                  @click="onChangeBot(bot)"
                  :class="activeBot.code === bot.code ? 'active' : ''"
              >
                <v-list-tile-title>{{ bot.name }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </div>
        </v-menu>
      </div>
    </div>
    <div id="rating-report-body" class="fill-height">
      <div class="rating-report-drawer">
        <router-link :to="item.to" active-class="drawer-item-active" v-for="item in drawerItems"
                     v-bind:key="item.title">
          <div class="drawer-item">
            <v-icon size="24">{{ item.icon }}</v-icon>
          </div>
        </router-link>
        <div style="flex-grow: 1; width: 100%; background-color: white"></div>
      </div>
      <div class="rating-report-content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import {mapState} from "vuex";
import StaffService from "@/services/staff.service";
import ActionTypes from "@/store/ActionTypes";

export default {
  name: "RatingReport",
  async mounted() {
    let has_permission = await this.hasPermission();
    if(!has_permission){
      this.$router.push('/forbidden')
    }
    this.initBotStaffList();
  },
  computed: {
    ...mapState(['botStaffList', 'user']),
    hasAdminRole() {
      return StaffService.checkStaffHasRole(this.$route.params.botCode, this.user.id, [10, 9])
    },
    hasManageRole() {
      return StaffService.checkStaffHasRole(this.$route.params.botCode, this.user.id, [10, 9, 5])
    },
    activeBot() {
      const botCode = this.$route.params.bot_code;
      if (botCode) {
        let bot = _.find(this.botStaffList, o => o.bot_code === botCode);
        return bot ? {code: bot.bot_code, name: bot.bot_name} : {}
      }
      return {}
    },
    botList() {
      return _.map(this.botStaffList, o => {
        return {name: o.bot_name, code: o.bot_code}
      });
    },
    drawerItems() {
      return [
        {
          title: 'Overview',
          icon: 'mdi-chart-bar',
          to: `/rating-report/${this.activeBot.code}/rate-agent/overview`
        },
        {
          title: 'Details',
          icon: 'mdi-format-list-bulleted',
          to: `/rating-report/${this.activeBot.code}/rate-agent/details`
        }
      ]
    }
  },
  methods: {
    onChangeBot(bot) {
      this.$store.commit(ActionTypes.BOT, bot)
      this.$router.push('/rating-report/' + bot.code)
    },
    async hasPermission() {
      return await StaffService.checkStaffHasRole(this.$route.params.bot_code, this.user.id, [10, 9, 5])
    },
    initBotStaffList() {
      if (this.botStaffList.length < 1) {
        this.$store.dispatch(this.$ActionTypes.GET_BOT_STAFF);
      }
    },
  }
}
</script>

<style scoped lang="scss">
@import "components/style/rating-report";
</style>
